import React, { lazy } from 'react'
import HorizontalCard from '../HorizontalCard'
import useExhibitorMutation from '../../../components/dashboard/hooks/useExhibitorMutation'
import { useFlagsContext } from '../../../providers'
import { FLAGS } from '../../../config'

const ArchiveActions = lazy(() => import('../../buttons/ArchiveActionsButtons'))

export default function HorizontalHRLogoCard({
  data,
  basePath,
  showArchiveButton,
  booth,
  addProfile,
  headingLevel = 'h3',
}) {
  const { [FLAGS.ARCHIVE_ACTIONS]: archiveActionsFlag } = useFlagsContext()
  const { mutateExhibitor } = useExhibitorMutation()
  const isLocked = true
  const logoData = { ...data, imgSrc: data.url }

  const removeAttachment = async (id) => {
    const logoType = booth?.whiteOnTransparentLogo?.id === id ? 'whiteOnTransparentLogo' : 'highResolutionLogo'

    const updatedBooth = await mutateExhibitor({
      id: booth.id,
      locale: booth.contentLocale,
      [logoType]: '',
    })

    addProfile(updatedBooth)
  }

  return (
    <HorizontalCard
      key={data?.id}
      data={logoData}
      headingLevel={headingLevel}
      to={`${basePath}${data?.id}`}
      contentId={data.id}
      isLocked={isLocked || undefined}
      actions={
        showArchiveButton && archiveActionsFlag.isOn && <ArchiveActions data={data} removeData={removeAttachment} />
      }
    />
  )
}
